import { render, staticRenderFns } from "./StatusViewer.vue?vue&type=template&id=b4bcd4b6&"
import script from "./StatusViewer.vue?vue&type=script&lang=js&"
export * from "./StatusViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports